import React, { createContext, useMemo, useState } from 'react';

import type { DesignBuilding } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';

const context = createContext<{
  building: DesignBuilding | undefined;
  setBuilding: (building: any) => void;
}>({ building: undefined, setBuilding: () => undefined });

const Provider = ({ children }: { children: React.ReactNode }) => {
  const [building, setBuilding] = useState<DesignBuilding | undefined>();
  const value = useMemo(
    () => ({ building, setBuilding }),
    [building, setBuilding],
  );
  return <context.Provider value={value}>{children}</context.Provider>;
};

export { Provider, context };
